import { render, staticRenderFns } from "./DetachRolefromResponsibilityDialog.vue?vue&type=template&id=fdd879f0"
import script from "./DetachRolefromResponsibilityDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DetachRolefromResponsibilityDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports